__turbopack_context__.v({
  "richText": "RichText-module-scss-module__ZDJi6a__richText",
});
